import { Collapse, Icon, IconButton, Tooltip } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';

import { ButtonV2 } from '~/src/dash/components/buttons/ButtonV2';
import { Col, Cols, Row, Rows } from '~/src/dash/components/layout';
import { ILiveLogsConfigField } from '~/src/dash/components/LiveLogs/common';
import { Text } from '~/src/dash/components/text';

export interface ITableDetailPanel {
  data: Record<string, any>;
  fields: Array<ILiveLogsConfigField>;
}

export const TableDetailPanel = ({ data, fields }: ITableDetailPanel) => {
  const [activeIdx, setActiveIdx] = useState(-1);

  return (
    <Rows style={{ paddingBottom: 0, width: '25rem' }}>
      {fields.map((field: ILiveLogsConfigField, idx) =>
        field.isCollapsible ? (
          <Row noPadding>
            <Cols>
              <Col
                style={{ marginRight: '1em' }}
                onClick={() => setActiveIdx(activeIdx === idx ? -1 : idx)}
              >
                <IconButton>{activeIdx === idx ? <ExpandLess /> : <ExpandMore />}</IconButton>
              </Col>

              <Col style={{ marginRight: '1em' }}>
                <Cols style={{ alignItems: 'center', paddingTop: '4px' }}>
                  <Col>
                    <Text small>{field.label}</Text>
                  </Col>
                  <Col style={{ marginLeft: '0.5em' }}>
                    <Tooltip title={'Copy'}>
                      <ButtonV2 clearBackground onClick={() => copy(data[field.key])}>
                        <Icon style={{ fontSize: '1em' }}>file_copy</Icon>
                      </ButtonV2>
                    </Tooltip>
                  </Col>
                </Cols>
                <Collapse in={activeIdx === idx}>{field.render && field.render(data)}</Collapse>
              </Col>
            </Cols>
          </Row>
        ) : (
          <Row noPadding>
            <Cols>
              <Col style={{ marginRight: '1em' }}>
                <Cols style={{ alignItems: 'center', paddingTop: '4px' }}>
                  <Col>
                    <Text small>{field.label}</Text>
                  </Col>
                  <Col style={{ marginLeft: '0.5em' }}>
                    <Tooltip title={'Copy'}>
                      <ButtonV2 clearBackground onClick={() => copy(data[field.key])}>
                        <Icon style={{ fontSize: '1em' }}>file_copy</Icon>
                      </ButtonV2>
                    </Tooltip>
                  </Col>
                </Cols>
                {field.render && field.render(data)}
              </Col>
            </Cols>
          </Row>
        ),
      )}
    </Rows>
  );
};
